import { getRemoteUrl, serializeParams } from '../utils/util';
var HornConfigGetter = /** @class */ (function () {
    function HornConfigGetter(ctx, request) {
        this.ctx = ctx;
        this.request = request;
    }
    /** 单发获取配置元信息 */
    HornConfigGetter.prototype.getSingleConfigInfo = function (hornId, eTag, query) {
        var reqOption = {
            method: 'GET',
            params: this._buildParams(hornId, query),
        };
        if (eTag) {
            reqOption.headers = { 'If-None-Match': eTag };
        }
        var URL = getRemoteUrl('single', this.ctx.isSankuaiOnly, this.ctx.host);
        return this.request(URL, reqOption).then(function (res) {
            var status = res.status, data = res.data, headers = res.headers;
            var isModify = status !== 304;
            var ret = isModify
                ? {
                    customer: data.customer,
                    horn: data.horn,
                    hornId: hornId,
                    etag: headers['etag'],
                }
                : null;
            //  dev mock
            // if (ret) {
            //   ret.horn.pollDuration = 1
            //   ret.horn.cacheDuration = 2
            // }
            return ret;
        });
    };
    /**
     *  batchRegisters 长度为 0 ，则不会发送请求，会直接返回空数组
     * 批量获取 horn 配置的元信息, 如果给配置传了 etag ，如果文件没修改，则返回值里面不会有这个配置信息
     * */
    HornConfigGetter.prototype.getBatchHornConfigInfos = function (batchRegisters) {
        if (batchRegisters.length === 0) {
            return Promise.resolve([]);
        }
        var data = batchRegisters.reduce(function (prev, cur) {
            prev[cur.hornId] = {
                query: serializeParams(cur.params),
                etag: cur.etag,
            };
            return prev;
        }, {});
        var URL = getRemoteUrl('batch', this.ctx.isSankuaiOnly, this.ctx.host);
        return this.request(URL, {
            method: 'POST',
            params: this._buildParams(),
            data: data,
        }).then(function (res) {
            var data = res.data;
            var dataCollects = Object.keys(data).map(function (cur) {
                var val = data[cur];
                var metaData = {
                    hornId: cur,
                    customer: val.data.customer,
                    horn: val.data.horn,
                    etag: val.etag,
                };
                //  dev mock
                // metaData.horn.pollDuration = 1
                // metaData.horn.cacheDuration = 2
                return metaData;
            });
            return dataCollects;
        });
    };
    /**
     * 构建最终调用 horn 接口的查询参数
     * @param {ConfigParams} params 用户传入的查询参数
     * @return {ConfigParams} 返回最终调用 horn 接口的查询参数
     */
    HornConfigGetter.prototype._buildParams = function (hornId, params) {
        return Object.assign({}, params, this.ctx.globalParams, hornId
            ? {
                from: hornId,
            }
            : null);
    };
    return HornConfigGetter;
}());
export default HornConfigGetter;
//# sourceMappingURL=horn-config-getter.js.map